import React from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";

const solutions = [
  {
    css: "b1",
    desc: "$singlee_cr3",
  },
  {
    css: "b2",
    desc: "$singlee_cr4",
  },
  {
    css: "b3",
    desc: "$singlee_cr5",
  },
  {
    css: "b4",
    desc: "$singlee_cr6",
  },
  { css: "b5", desc: "$singlee_cr7" },
  { css: "b6", desc: "$singlee_cr8" },
];

function Index() {
  const { t } = useTranslation();

  const [firtstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(-100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.2, once: true }
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.2, once: true }
  );

  return (
    <div className={css.contain}>
      <div className={css.maintitle}>{t("$singlee_cr1")}</div>

      <div className={css.first} ref={firtstRef}>
        <animated.div className={css.left} style={firstRefStyle}>
          <div className={css.title}>{t("$singlee_js")}</div>
          <div className={css.desc}>{t("$singlee_cr2")}</div>
        </animated.div>
        <div className={css.right}></div>
      </div>

      <div className={css.second} ref={secondRef}>
        <div className={css.subtitle}>{t("解决方案")}</div>
        <animated.div className={css.inner} style={secondRefStyle}>
          {solutions.map((item, index) => (
            <div className={css.item} key={index}>
              <div className={`${css.icon} ${css[item.css]}`}></div>
              <div className={css.desc}>{t(item.desc)}</div>
            </div>
          ))}
        </animated.div>
      </div>
    </div>
  );
}

export default React.memo(Index);
